import {Routes} from '@angular/router';
import {ReleasePageComponent} from './release-page.component';
import {ReleaseAuthorizationScreenComponent} from './steps/authorization/release-authorization-screen.component';

/**
 * Created by Rodrigo Quesada on 03/03/17.
 */
const routes: Routes = [{
    path: 'releaseAuthorization',
    component: ReleasePageComponent,
    children: [{path: '', component: ReleaseAuthorizationScreenComponent}],
    data: {section: {title: 'Release Authorization'}, impersonationAllowed: true}
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/release/release-page.routing.ts